export { FaqDesktop } from './ui'
